import { ok, err } from '@guardian/types';
const parseParagraphs = (dataFromBraze) => {
    const isParagraphKey = (k) => /^paragraph\d$/.test(k);
    const orderedParagraphKeys = Object.keys(dataFromBraze)
        .filter(isParagraphKey)
        .sort();
    const paragraphs = [];
    for (const key of orderedParagraphKeys) {
        const value = dataFromBraze[key];
        if (value)
            paragraphs.push(value);
    }
    return paragraphs;
};
export const parseBrazeEpicParams = (dataFromBraze) => {
    const requiredBasicFields = [
        'buttonText',
        'buttonUrl',
        'ophanComponentId',
    ];
    const missingBasicFields = requiredBasicFields.filter((key) => !dataFromBraze[key]);
    if (missingBasicFields.length > 0) {
        return err(`Missing field(s): ${missingBasicFields}`);
    }
    const paragraphs = parseParagraphs(dataFromBraze);
    if (paragraphs.length < 1) {
        return err('Missing paragraphs');
    }
    const variant = {
        heading: dataFromBraze.heading,
        paragraphs,
        highlightedText: dataFromBraze.highlightedText,
        cta: {
            text: dataFromBraze.buttonText,
            baseUrl: dataFromBraze.buttonUrl,
        },
        ophanComponentId: dataFromBraze.ophanComponentId,
    };
    return ok(variant);
};
